export const MERCHANT_BACKGROUND_COLOR =
	process.env.REACT_APP_MERCHANT_BACKGROUND_COLOR;
export const MERCHANT_LOGO_WHITE = process.env.REACT_APP_MERCHANT_LOGO_WHITE;
export const LOCAL_HOST = process.env.REACT_APP_LOCAL_HOST;

export const X_FOWARD_HOST = process.env.REACT_APP_X_FOWARD;
